module.exports = __webpack_public_path__ + "static/media/ic_left.52cb7b1d.svg";